import React from 'react';
import { CAMERA_PRESETS } from '../camera.director';
import { LOOK } from '../../../settings/render';
import './view.controls.scss';

/**
 * Overlay controls for magazine camera snaps + day/evening look.
 */
const ViewControls = ({

  onSnap,
  lookId,
  onLookChange,

}) => {

  return (

    <div className = "view-controls">

      <div className = "view-controls__group">

        <span className = "view-controls__label">Ракурс</span>

        { Object.entries( CAMERA_PRESETS ).map(([ id, preset ]) => (

          <button

            key = { id }
            type = "button"
            className = "view-controls__btn"
            onClick = { () => onSnap && onSnap( id ) }
            title = { preset.label }

          >

            { preset.label }

          </button>

        ))}

      </div>

      <div className = "view-controls__group">

        <span className = "view-controls__label">Свет</span>

        <button

          type = "button"
          className = { `view-controls__btn${ lookId === LOOK.DAY ? ' is-active' : '' }` }
          onClick = { () => onLookChange && onLookChange( LOOK.DAY ) }

        >

          День

        </button>

        <button

          type = "button"
          className = { `view-controls__btn${ lookId === LOOK.EVENING ? ' is-active' : '' }` }
          onClick = { () => onLookChange && onLookChange( LOOK.EVENING ) }

        >

          Вечер

        </button>

      </div>

    </div>

  );

}

export default ViewControls;
